import * as yup from 'yup';
import ValidationUtil from "../Utils/ValidationUtil";

class ResetValidation {

    static async validate(form) {
        try {

            let validate = yup.object().shape({
                password: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                password_confirmed: yup.string()
                    .oneOf([yup.ref('password'),], ValidationUtil.MSG_PASSWORD_NOT_EQUAL)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
            });

            validate.validateSync(form, {abortEarly: false})

            return true;

        } catch (e) {
            let erros = [];
            e.inner.forEach(function (value, index) {
                erros[value.path] = value.message;
            });

            return erros;
        }
    }

}

export default ResetValidation;